import { useState, useEffect } from 'react';
import { formatNumber } from "src/MarketDataComponents/Helpers";
import { generateGuid } from 'src/Utils';

export default function MarketCap({marketCapitalisationCat, marketCapitalisation, formattedDate}) {
    const [showTable, setShowTable] = useState(false);

    useEffect(() => {
        let showTable = false;
        if (marketCapitalisation && marketCapitalisation.breakdownValues) {
            marketCapitalisation.breakdownValues.map(cap => {
                if (cap.value) {
                    showTable = true;
                }
            });

            if (!marketCapitalisationCat || !marketCapitalisationCat.breakdownValues) {
                marketCapitalisationCat.breakdownValues = [];
                marketCapitalisation.breakdownValues.map(cap => {
                    marketCapitalisationCat.breakdownValues.push({label: cap.label, value: null});
                });
            }
        }

        setShowTable(showTable);
    }, []);

    const renderRows = () => {
        return marketCapitalisation.breakdownValues.map((cap, i) => {
            return marketCapitalisationCat.breakdownValues.map(cat => {
                if (cap.label === cat.label) {
                    return <tr key={generateGuid()}>
                        <td data-testid={`${(cap.label).toLowerCase()}Label`}>{cap.label}</td>
                        <td data-testid={`fundValue${i}`}>{formatNumber(cap.value, 2)}</td>
                        <td data-testid={`catValue${i}`}>{cat.value !== null ? formatNumber(cat.value, 2) : '-'}</td>
                    </tr>
                }
            })
        });
    }

    return <div className="card z-depth-0 margin-0">
        {showTable ? <div className="card-content padding-top-0 padding-right-0-sm padding-bottom-30-sm padding-left-0-sm">
            <div className="ajb-grid-row">
                <span className="card-title float-left float-none-sm" data-testid="marketCaptialisationHeader">Mkt cap %</span>
                {formattedDate ? <p className="h7 float-right float-none-sm" data-testid="marketCaptialisationDate">{formattedDate}</p> : null}
            </div>
            <div className="ajb-grid-row">
                <table className="data-table data-table--small data-table--scroll margin-0 highlight">
                    <thead>
                        <tr>
                            <th></th>
                            <th data-testid="fundTableHead">Fund</th>
                            <th data-testid="catTableHead">Category</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderRows()}
                    </tbody>
                </table>
            </div>
        </div> : null}
    </div>
}